var _rect, _circle, _rect2, _circle2, _path, _rect3, _circle3, _circle4, _path2, _path3, _path4, _circle5, _path5, _circle6, _path6, _rect4, _circle7, _path7, _path8, _circle8, _rect5, _path9, _rect6, _circle9, _path10, _line, _rect7, _line2, _rect8, _circle10, _path11, _line3, _rect9, _line4, _rect10, _rect11, _rect12, _rect13, _rect14, _circle11, _circle12, _circle13, _rect15, _path12, _circle14, _circle15, _circle16, _path13, _path14, _path15, _path16, _path17, _path18, _circle17, _circle18, _path19, _ellipse, _circle19, _path20, _path21, _path22, _path23, _ellipse2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHero1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b20bc320-2fc8-4403-a458-9220829d6284",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 645.2965,
    height: 564.50774,
    viewBox: "0 0 645.2965 564.50774",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Load_more") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 229.16609,
    y: 256.36275,
    width: 393.53455,
    height: 201.56648,
    fill: "#60dbfb"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 487.25679,
    cy: 204.16855,
    r: 36.41465,
    fill: "#ff6584"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 347.95965,
    y: 377.15642,
    width: 1.1903,
    height: 66.05518,
    fill: "#3f3d56"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 348.55465,
    cy: 377.15668,
    r: 9.34108,
    fill: "#3f3d56"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M625.9064,585.61372s-1.33444-28.701-28.69046-25.36486",
    transform: "translate(-277.35175 -167.74613)",
    fill: "#3f3d56"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 479.54286,
    y: 223.34723,
    width: 1.1903,
    height: 220.32758,
    fill: "#3f3d56"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 480.13784,
    cy: 223.24272,
    r: 9.34108,
    fill: "#3f3d56"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 451.44739,
    cy: 382.65095,
    r: 9.34108,
    fill: "#3f3d56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M757.4896,438.70353s-1.33444-28.701-28.69046-25.36486",
    transform: "translate(-277.35175 -167.74613)",
    fill: "#3f3d56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M757.4896,520.06751s-1.33444-28.701-28.69046-25.36487",
    transform: "translate(-277.35175 -167.74613)",
    fill: "#3f3d56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M758.08142,608.91713l-1.18332-.12787c.03487-.32256,3.31168-32.44842-10.14253-48.63485a25.05081,25.05081,0,0,0-18.00211-9.16379l.09183-1.18681a26.20081,26.20081,0,0,1,18.82683,9.59155C761.44773,575.9712,758.11687,608.58933,758.08142,608.91713Z",
    transform: "translate(-277.35175 -167.74613)",
    fill: "#3f3d56"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 508.83239,
    cy: 382.65095,
    r: 9.34108,
    fill: "#3f3d56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M756.90216,608.91713c-.03545-.3278-3.36631-32.94593,10.4093-49.52177a26.20083,26.20083,0,0,1,18.82683-9.59155l.09183,1.18681a25.04767,25.04767,0,0,0-18.00326,9.16553c-13.45712,16.19283-10.17624,48.31055-10.14137,48.63311Z",
    transform: "translate(-277.35175 -167.74613)",
    fill: "#3f3d56"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 509.40137,
    cy: 295.02821,
    r: 9.34108,
    fill: "#3f3d56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M757.47174,518.32192c-.03487-.30222-3.28494-30.41073,9.87867-46.34725a26.80627,26.80627,0,0,1,19.35688-9.79381l.09183,1.18682a25.657,25.657,0,0,0-18.531,9.36488c-12.84511,15.55118-9.64793,45.15753-9.61422,45.45453Z",
    transform: "translate(-277.35175 -167.74613)",
    fill: "#3f3d56"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 417.65779,
    y: 308.87408,
    width: 1.1903,
    height: 134.49037,
    fill: "#3f3d56"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 418.2527,
    cy: 308.87404,
    r: 9.34108,
    fill: "#3f3d56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M695.60446,514.66221s-1.33444-28.701-28.69046-25.36486",
    transform: "translate(-277.35175 -167.74613)",
    fill: "#3f3d56"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M696.19636,608.60735l-1.18333-.129c.03429-.31733,3.29483-31.93929-10.03965-48.00018a25.17078,25.17078,0,0,0-18.10556-9.20331l.09183-1.18681a26.32024,26.32024,0,0,1,18.93144,9.63223C699.547,576.17113,696.23123,608.28478,696.19636,608.60735Z",
    transform: "translate(-277.35175 -167.74613)",
    fill: "#3f3d56"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 389.56225,
    cy: 382.93544,
    r: 9.34108,
    fill: "#3f3d56"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 315.20145,
    y: 442.63969,
    width: 192.82837,
    height: 1.1903,
    fill: "#3f3d56"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M922.64825,692.85941H473.12237V167.74613H922.64825Zm-447.52588-2H920.64825V169.74613H475.12237Z",
    transform: "translate(-277.35175 -167.74613)",
    fill: "#3f3d56"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 196.77062,
    y: 45.16553,
    width: 447.52588,
    height: 2,
    fill: "#3f3d56"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 623.89945,
    cy: 23.79628,
    r: 7.7987,
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M901.25079,199.84134a8.29883,8.29883,0,1,1,8.29883-8.29883A8.30778,8.30778,0,0,1,901.25079,199.84134Zm0-15.59765a7.29883,7.29883,0,1,0,7.29883,7.29882A7.30647,7.30647,0,0,0,901.25079,184.24369Z",
    transform: "translate(-277.35175 -167.74613)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 620.39003,
    y1: 20.28686,
    x2: 627.40886,
    y2: 27.30569,
    fill: "#fff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 900.75133,
    y: 186.57923,
    width: 0.99989,
    height: 9.92608,
    transform: "translate(-148.83966 525.60931) rotate(-44.99801)"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 627.40886,
    y1: 20.28686,
    x2: 620.39003,
    y2: 27.30569,
    fill: "#fff"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 896.28824,
    y: 191.04232,
    width: 9.92608,
    height: 0.99989,
    transform: "translate(-148.8222 525.63619) rotate(-45)"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 623.89945,
    cy: 23.79628,
    r: 7.7987,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M901.25079,199.84134a8.29883,8.29883,0,1,1,8.29883-8.29883A8.30778,8.30778,0,0,1,901.25079,199.84134Zm0-15.59765a7.29883,7.29883,0,1,0,7.29883,7.29882A7.30647,7.30647,0,0,0,901.25079,184.24369Z",
    transform: "translate(-277.35175 -167.74613)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 620.39003,
    y1: 20.28686,
    x2: 627.40886,
    y2: 27.30569,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 900.75133,
    y: 186.57923,
    width: 0.99989,
    height: 9.92608,
    transform: "translate(-148.83966 525.60931) rotate(-44.99801)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 627.40886,
    y1: 20.28686,
    x2: 620.39003,
    y2: 27.30569,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 896.28824,
    y: 191.04232,
    width: 9.92608,
    height: 0.99989,
    transform: "translate(-148.8222 525.63619) rotate(-45)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 229.1651,
    y: 18.99707,
    width: 69.58843,
    height: 9.5984,
    fill: "#3f3d56"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 350.34494,
    y: 18.99707,
    width: 69.58843,
    height: 9.5984,
    fill: "#3f3d56"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 471.52479,
    y: 18.99707,
    width: 69.58843,
    height: 9.5984,
    fill: "#3f3d56"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 298.75352,
    y: 116.18091,
    width: 242.35969,
    height: 28.79521,
    fill: "#3f3d56"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 403.13616,
    cy: 496.51766,
    r: 5.999,
    fill: "#3f3d56"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 419.93337,
    cy: 496.51766,
    r: 5.999,
    fill: "#3f3d56"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 436.73057,
    cy: 496.51766,
    r: 5.999,
    fill: "#3f3d56"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 136.49414,
    y: 181.08605,
    width: 71.11658,
    height: 77.12643,
    fill: "#f2f2f2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M494.742,421.3721H421.6253V342.24515H494.742Zm-71.1167-2H492.742V344.24515H423.6253Z",
    transform: "translate(-277.35175 -167.74613)",
    fill: "#3f3d56"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 167.30969,
    cy: 214.56317,
    r: 5.00821,
    fill: "#60dbfb"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 181.33268,
    cy: 214.56317,
    r: 5.00821,
    fill: "#60dbfb"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 195.35567,
    cy: 214.56317,
    r: 5.00821,
    fill: "#60dbfb"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M337.74555,705.04143s36.5313,19.93471,35.04033,26.13565c-.80886,3.364-20.45023-1.66108-38.9294-8.06844-15.58348-5.40333,8.64684-3.01128,6.70753-6.17838C336.325,710.00753,337.74555,705.04143,337.74555,705.04143Z",
    transform: "translate(-277.35175 -167.74613)",
    fill: "#2f2e41"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M425.56257,699.21065s40.17933,10.842,40.17933,17.21972-68.87886,0-74.61876-5.73991S425.56257,699.21065,425.56257,699.21065Z",
    transform: "translate(-277.35175 -167.74613)",
    fill: "#2f2e41"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M356.68371,418.59308l17.21972,28.69953s28.69952,74.61876,34.43942,120.538,40.17934,126.2779,28.69953,137.75771-68.87886,12.11758-68.87886,0V470.25223Z",
    transform: "translate(-277.35175 -167.74613)",
    fill: "#2f2e41"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M356.68371,418.59308l17.21972,28.69953s28.69952,74.61876,34.43942,120.538,40.17934,126.2779,28.69953,137.75771-68.87886,12.11758-68.87886,0V470.25223Z",
    transform: "translate(-277.35175 -167.74613)",
    opacity: 0.1
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M310.76447,395.63346v22.95962c0,5.73991,34.43943,5.73991,34.43943,5.73991V401.37337Z",
    transform: "translate(-277.35175 -167.74613)",
    fill: "#a0616a"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M327.98419,407.11327l-16.90083,5.421s-17.5386,33.48278-11.7987,51.34026,22.95962,115.43587,22.95962,115.43587v63.139s-34.43943,57.399-17.21971,68.87886,51.65914,23.59739,57.39905,17.21971S373.90343,481.732,373.90343,481.732V447.29261l-5.73991-45.91924Z",
    transform: "translate(-277.35175 -167.74613)",
    fill: "#2f2e41"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.47269,
    cy: 82.68551,
    r: 33.61758,
    fill: "#2f2e41"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.05366,
    cy: 38.42237,
    r: 33.61758,
    fill: "#2f2e41"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M292.40845,234.006a33.6194,33.6194,0,0,0,51.91444-17.652,33.61943,33.61943,0,1,1-65.57883-13.78632A33.607,33.607,0,0,0,292.40845,234.006Z",
    transform: "translate(-277.35175 -167.74613)",
    fill: "#2f2e41"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.23885,
    cy: 79.04359,
    rx: 21.85142,
    ry: 17.08893,
    fill: "#2f2e41"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.39075,
    cy: 89.81074,
    r: 28.38064,
    fill: "#a0616a"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M345.2039,275.09546s5.73991,11.47981-5.7399,17.21972,22.95962,28.69952,22.95962,28.69952l11.47981-40.17933Z",
    transform: "translate(-277.35175 -167.74613)",
    fill: "#a0616a"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M350.94381,298.05508s-11.47981-17.21971-17.21972-5.7399-34.43943,45.91923-34.43943,80.35866,0,34.43943,5.73991,34.43943,22.95962-5.7399,28.69952,0,28.69953,0,28.69953,0l5.7399-51.65914s5.73991-28.69953,0-34.43943S350.94381,298.05508,350.94381,298.05508Z",
    transform: "translate(-277.35175 -167.74613)",
    fill: "#60dbfb"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M322.24428,321.0147s-17.21971,86.09857,0,91.83848,68.87886,28.06175,68.87886,22.32185,5.7399-11.47981,5.7399-11.47981,5.73991,5.7399,5.73991,0v-10.842L345.2039,389.89356v-57.399s11.47981-28.69952,0-28.69952S322.24428,321.0147,322.24428,321.0147Z",
    transform: "translate(-277.35175 -167.74613)",
    fill: "#60dbfb"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M396.863,412.85318s39.54157,0,40.17934,11.47981-40.17934-.63777-40.17934-.63777Z",
    transform: "translate(-277.35175 -167.74613)",
    fill: "#a0616a"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 359.23478,
    cy: 238.74273,
    rx: 25.82957,
    ry: 14.34976,
    transform: "translate(-332.48599 -48.77832) rotate(-17.48536)",
    fill: "#2f2e41"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHero1);
export default __webpack_public_path__ + "static/media/hero-1.0c27d3fc666038c22eee47de77ee2821.svg";
export { ForwardRef as ReactComponent };